var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AdvancedPage',_vm._g(_vm._b({ref:"pageRef",staticClass:"advanced-page-list",attrs:{"actions":_vm.actionBtns,"operations":_vm.operationBtns,"extra-grid-options":_vm.extraGridOptions,"search-before":_vm.searchBefore,"is-init-query":_vm.isInitQuery},on:{"report":_vm.handleReport}},'AdvancedPage',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }